import React from 'react';

import PressHero from '../image-hero/image-hero';
import Spacer from '../spacer/spacer';
import PressKitBlock from './press-kit-block/press-kit-block';
import PressKitBanner from './press-banner/press-banner';
import PressKitItems from '../../lib/company-content-src/press-kit-content';
import PressKitBannerContent from '../../lib/company-content-src/press-kit-banner-content';

const PressKit = () => (
  <div className="press-kit">
    <PressHero
      backgroundClassName="press-kit-hero"
      preheader="Press Kit"
      title="Our brand resources"
      body="Looking for photography, video assets or logos? We got you."
      bodyMobile="Looking for photography, video assets or logos? We got you."
      opacityLevel={0.7}
    />
    <Spacer />
    <PressKitBlock {...PressKitItems} />
    <PressKitBanner {...PressKitBannerContent} />
  </div>
);

PressKit.displayName = 'PressKit';

export default PressKit;
